const setBlocks = type => (event, editor) => {
  event.preventDefault()
  editor.setBlocks(type)
  editor.moveFocusToStartOfNode(editor.value.startBlock).delete()
}

const wrapList = type => (event, editor) => {
  event.preventDefault()
  editor.wrapList({ type })
  editor.moveFocusToStartOfNode(editor.value.startBlock).delete()
}

const shortcut = (regex, handler) => {
  return (event, editor, _next) => {
    const text = editor.value.startBlock.text
    const result = text.match(regex)
    if (result) {
      handler(event, editor, result)
      return true
    }
    return false
  }
}

export default config => {
  const shortcuts = [
    shortcut(/^#$/, setBlocks("heading-one")),
    shortcut(/^##$/, setBlocks("heading-two")),
    shortcut(/^###$/, setBlocks("heading-three")),
    shortcut(/^####$/, setBlocks("heading-four")),
    shortcut(/^#####$/, setBlocks("heading-five")),
    shortcut(/^######$/, setBlocks("heading-six")),
    config.lists && shortcut(/^1\.?$/, wrapList("ordered-list")),
    config.lists && shortcut(/^(-|\*)$/, wrapList("unordered-list"))
  ].filter(Boolean)

  return {
    onKeyDown(event, editor, next) {
      if (event.key === " ") {
        shortcuts.find(shortcut => {
          if (shortcut(event, editor, next)) {
            return
          }
        })
      }
      return next()
    }
  }
}
